import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import CRM from "../../../../../utils/CrmService";

export default function TrmBancoHipotecarioForm(props) {
  const { record, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.bnc_id);
  const [loadingButton, setLoadingButton] = useState(false);

  useEffect(() => {
    setCurId(record.bnc_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await CRM.sendMaestro(
      currentUser,
      curId,
      "TrmBancoHipotecario",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE BANCOS HIPOTECARIOS",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE BANCOS HIPOTECARIOS",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="TrmBancoHipotecario"
      onFinish={guardarCambios}
      initialValues={{
        bnc_nombre: record.bnc_id > 0 ? record.bnc_nombre : "",
        bnc_contacto: record.bnc_id > 0 ? record.bnc_contacto : "",
        bnc_telefono: record.bnc_id > 0 ? record.bnc_telefono : "",
        bnc_email: record.bnc_id > 0 ? record.bnc_email : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.bnc_id > 0
            ? "ACTUALIZAR BANCOS HIPOTECARIOS"
            : "AGREGAR BANCOS HIPOTECARIOS"}
        </Title>
      </Form.Item>
      <Form.Item
        name="bnc_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.bnc_id > 0 ? record.bnc_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="bnc_contacto"
        label="Contacto"
        rules={[
          {
            required: true,
            message: "El contacto es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.bnc_id > 0 ? record.bnc_contacto : ""}
        />
      </Form.Item>
      <Form.Item
        name="bnc_telefono"
        label="Telefono"
        rules={[
          {
            required: true,
            message: "El telefono es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.bnc_id > 0 ? record.bnc_telefono : ""}
        />
      </Form.Item>
      <Form.Item
        name="bnc_email"
        label="Email"
        rules={[
          {
            required: true,
            message: "El email es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.bnc_id > 0 ? record.bnc_email : ""}
        />
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
